import React, { useState } from 'react';
import '../style/legacy/./Contact.css';
import { FaUser, FaEnvelope, FaComment } from 'react-icons/fa';
import ConferenceNav from '../common/ConferenceNav';
import NewFooter from '../common/NewFooter';
import SEO from '../common/SEO';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    // Sending form data to backend API endpoint http://localhost:8000/api/send-email
    const response = await fetch('http://localhost:8000/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      alert('Message Submitted!');
      // / Scroll back to the form after submission
      const formElement = document.querySelector('.form-container');
      formElement.scrollIntoView({ behavior: 'smooth' });
    } else {
      alert('Failed to send message!');
    }
  };

  return (
    <>
      <SEO
        title="Contact Best Thesis Writing Services & Paper Help Bhopal"
        description="Contact Assurance Education Group for the best thesis writing services in bhopal, Mtech Thesis Writing, PhD Thesis writing help, Paper Writing Bhopal, and Plagiarism Check Bhopal."
        canonicalPath="/contact-form"
        keywords={[
          "best thesis writing services in bhopal",
          "Paper Writing Bhopal",
          "PhD Thesis writing service and help",
          "Mtech Thesis Writing",
          "Plagiarism Check Bhopal",
          "Research paper writing and publication"
        ]}
      />
      <ConferenceNav />
      <div className='contact-page'>
        <div className='contact-container'>
          <div className='form-container'>
            <h2 className='form-heading'>Contact Us</h2>
            <form className='contact-form' onSubmit={handleSubmit}>
              <div className='form-group'>
                <FaUser className='input-icon' />
                <input
                  type='text'
                  name='name'
                  placeholder='Your Name'
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='form-group'>
                <FaEnvelope className='input-icon' />
                <input
                  type='email'
                  name='email'
                  placeholder='Your Email'
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className='form-group'>
                <FaComment className='input-icon' />
                <textarea
                  name='message'
                  placeholder='Your Message'
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type='submit' className='submit-btn'>
                Send Message
              </button>
            </form>
          </div>

          <div className='location-container'>
            <h2 className='location-heading'>Our Location</h2>

            {/* Map with an exact location */}
            <div className='map-container'>
              <iframe
                title='AEG Consultancy Services Office Location'
                className='map'
                src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7331.4140045990725!2d77.47558749999999!3d23.253746800000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c42033f80d115%3A0x3248bd8eb9222d16!2sAssurance%20Educational%20Group%20%3A%20MTECH%20THESIS%2C%20PHD%20GUIDANCE%2C%20PAPER%20PUBLICATION!5e0!3m2!1sen!2sin!4v1775561903792!5m2!1sen!2sin'
                width='600'
                height='450'
                style={{ border: 0 }}
                allowFullScreen=''
                loading='lazy'
              ></iframe>
            </div>

            {/* Clickable Map */}
            <div
              className='map-clickable'
              onClick={() =>
                window.open(
                  'https://maps.app.goo.gl/be1aiUXio6vTMezt5'
                )
              }
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  window.open(
                    'https://maps.app.goo.gl/be1aiUXio6vTMezt5'
                  );
                }
              }}
              role='button'
              tabIndex={0}
              aria-label='Open location in Google Maps'
            >
              <p>Click to open location in Google Maps</p>
            </div>

            <div className='contact-details'>
              <p> Address:329 Kalpana Nagar, BHEL, Bhopal, Madhya Pradesh </p>
              <p>Pin No.:462022</p>
              <p>Email: aeggrouphelpdesk@gmail.com</p>
              <p>Contact No.: 6268558700</p>
            </div>
          </div>
        </div>
      </div>
      <NewFooter />
    </>
  );
};

export default ContactForm;
